var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoRequiredBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 0.416992C5.8313 0.416992 0.417969 5.83033 0.417969 12.5003C0.417969 19.1703 5.8313 24.5837 12.5013 24.5837C19.1713 24.5837 24.5846 19.1703 24.5846 12.5003C24.5846 5.83033 19.1713 0.416992 12.5013 0.416992Z",
    fill: "#5E93AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 6.45769C13.1672 6.45769 13.7109 7.00144 13.7109 7.66602V12.4994C13.7109 13.1639 13.1672 13.7077 12.5026 13.7077C11.838 13.7077 11.2943 13.1639 11.2943 12.4994V7.66602C11.2943 7.00144 11.838 6.45769 12.5026 6.45769Z",
    fill: "#EFFBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2943 17.3327C11.2943 16.6653 11.8353 16.1243 12.5026 16.1243V16.1243C13.1699 16.1243 13.7109 16.6653 13.7109 17.3327V17.3327C13.7109 18 13.1699 18.541 12.5026 18.541V18.541C11.8353 18.541 11.2943 18 11.2943 17.3327V17.3327Z",
    fill: "#EFFBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoRequiredBlue);
export default __webpack_public_path__ + "static/media/Icon_InfoRequired_Blue.39e18c4f5eed17a413691fea8d9db40a.svg";
export { ForwardRef as ReactComponent };